import axios from "axios";
import { getApiBaseUrl } from "../config/api";

/**
 * Load hostels with rooms for student enrollment pickers.
 * @returns {Promise<Array<{ id: string, name: string, rooms: Array<{ id: string, roomNumber: string, label: string, vacant: number, capacity: number, occupied: number }> }>>}
 */
export async function fetchHostelsForEnrollment(schoolId) {
    if (!schoolId) return [];
    const { data } = await axios.get(`${getApiBaseUrl()}/Hostels/${schoolId}`);
    return (Array.isArray(data) ? data : []).map((h) => {
        const hostelId = String(h._id || h.id || "");
        const hostelName = String(h.name || "Hostel").trim();
        const rooms = (Array.isArray(h.rooms) ? h.rooms : []).map((r) => {
            const roomId = String(r._id || r.id || "");
            const roomNumber = String(r.roomNumber ?? "").trim();
            const occupied = Number(r.occupied) || 0;
            const capacity = Number(r.capacity) || 0;
            const vacant = Number.isFinite(r.vacant) ? r.vacant : Math.max(0, capacity - occupied);
            return {
                id: roomId,
                roomNumber,
                label: `Room ${roomNumber} (${occupied}/${capacity} beds)`,
                vacant,
                capacity,
                occupied,
            };
        });
        return {
            id: hostelId,
            name: hostelName,
            gender: String(h.gender || "").trim(),
            rooms,
        };
    });
}

export function findHostelIdForRoom(hostels, roomId) {
    if (!roomId) return "";
    const rid = String(roomId);
    for (const hostel of hostels || []) {
        if ((hostel.rooms || []).some((r) => r.id === rid)) return hostel.id;
    }
    return "";
}

export function roomsForHostel(hostels, hostelId) {
    if (!hostelId) return [];
    const hostel = (hostels || []).find((h) => h.id === String(hostelId));
    return hostel?.rooms || [];
}
